(function ($, Drupal, window, document) {
  'use strict';
  // Example of Drupal behavior loaded.
  Drupal.behaviors.homepageHero = {
    attach: function homepageHero(context, settings) {
      if (typeof context['location'] !== 'undefined') {
        // Only fire on document load.

        $('#scrollToFirstSection').on('click', function () {

          // Find the first element
          const nearestSection = $('section[id^=scroll-]:first');

          // Animate scrolling to the first element
          let topPos = (nearestSection.offset().top) - 200;

          $('html, body').animate({
            scrollTop: topPos
          }, 500);

        });
      }
    }
  };
})(jQuery, Drupal, window, document);
